<div  style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
    <img src="./assets/media/svg/programming.svg" style="height: 500px;width: 500px;">
    <h1 style="font-size: 4em;"><b>Unautherized to access this page! </b></h1>
</div>
